import React, { Component } from 'react';
import helper from '../services/helper';

export default class BalancePrompt extends Component {

    constructor(props) {
        super(props);
        this.state = {
            amount: ''
        };
    }

    changeHandler(event) {
        this.setState({
            amount: event.target.value
        });
    }

    setAmount() {
        if(helper.isValidAmount(this.state.amount)) {
            this.props.onAction({
                action: 'update',
                value: parseFloat(this.state.amount)
            });
            this.setState({ amount: '' });
        } else {
            this.props.onAction({
                action: 'invalid'
            });
        }
    }

    handleOverlayClick() {
        this.props.onAction({
            action: 'close'
        });
    }

    render() {
        let style = {
            base: {
                pointerEvents: this.props.isVisible ? 'auto' : 'none',
                opacity: this.props.isVisible ? 1 : 0,
                position: 'fixed',
                top: this.props.isVisible ? 0 : 20,
                left: 0,
                right: 0,
                bottom: 0,
                width: 540,
                height: 252,
                borderRadius: 6,
                padding: 30,
                margin: 'auto',
                zIndex: 999,
                boxSizing: 'border-box',
                backgroundColor: '#38B08C',
                textAlign: 'center',
                boxShadow: '0 0 40px -5px rgba(0,0,0,0.4)',
                transition: 'all .3s ease-in-out',
            },
            title: {
                padding: '0 0 50px',
                fontSize: 24,
                fontWeight: 400,
                color: '#FFFFFF'
            },
            subtitle: {
                padding: '20px 0 15px',
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: 1,
                textTransform: 'uppercase',
                color: 'rgba(0,0,0,0.3)'
            },
            input: {
                float: 'left',
                width: '60%',
                padding: 20,
                boxSizing: 'border-box',
                backgroundColor: 'rgba(0,0,0,0.1)',
                fontSize: 24,
                fontWeight: 400,
                color: '#FFFFFF',
                borderRadius: '4px 0 0 4px',
            },
            button: {
                float: 'left',
                cursor: 'pointer',
                width: '40%',
                padding: 25,
                margin: 0,
                boxSizing: 'border-box',
                backgroundColor: '#FFFFFF',
                color: '#38B08C',
                fontSize: 16,
                fontWeight: 600,
                border: 'none',
                borderRadius: '0 4px 4px 0',
            }
        };

        return (
            <div style={style.base}>
                <h4 style={style.subtitle}>Balance update</h4>
                <h3 style={style.title}>What's in the bank today?</h3>
                <input style={style.input} value={this.state.amount} onChange={this.changeHandler.bind(this)} placeholder="0.00" autoFocus={true} />
                <button style={style.button} type="submit" onClick={this.setAmount.bind(this)}>Set amount</button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/BalancePrompt.js